/**
 * Classify Ory NOT_APPLICABLE rubric findings for posture-gap UI (POST-ARC.12d).
 *
 * @module client/utils/oryPostureGaps
 */

const DEFERRED_RULE_IDS = new Set(["BP-PWD-01", "BP-SESSION-01"]);

const DEFERRED_MARKERS = [/workspace key/i, /deferred to v2/i, /workspace api key/i];

/**
 * @param {string | null | undefined} ruleId
 * @param {string} description
 */
export function classifyOryPostureGap(ruleId, description) {
  const id = String(ruleId || "").trim();
  const text = String(description || "");
  if (DEFERRED_RULE_IDS.has(id) || DEFERRED_MARKERS.some((re) => re.test(text))) {
    return "deferred";
  }
  return "absent";
}

/**
 * @param {unknown} normalizedFindings
 */
export function extractOryPostureGaps(normalizedFindings) {
  const rows = Array.isArray(normalizedFindings) ? normalizedFindings : [];
  /** @type {object[]} */
  const absent = [];
  /** @type {object[]} */
  const deferred = [];

  for (const row of rows) {
    if (!row || typeof row !== "object" || row.status !== "NOT_APPLICABLE") continue;
    const ruleId = row.rule_id || row.ruleId;
    const kind = classifyOryPostureGap(ruleId, row.description || row.title || "");
    if (kind === "deferred") deferred.push(row);
    else absent.push(row);
  }

  return { absent, deferred, total: absent.length + deferred.length };
}

/**
 * @param {unknown} normalizedFindings
 */
export function hasOryPostureGaps(normalizedFindings) {
  return extractOryPostureGaps(normalizedFindings).total > 0;
}
